/**
 * EnOcean adapter — IOT-Z20-AMBIENT-SCAFFOLD-1 (ASPIRATIONAL).
 *
 * EnOcean specializes in energy-harvesting wireless sensors (kinetic from
 * motion, thermal from gradients, solar). No batteries, no wires. Sensors
 * report environmental + occupancy telemetry intermittently when ambient
 * energy is available.
 *
 * Operational status: ASPIRATIONAL — type-system awareness only. Activation
 * deferred until the ambient-IoT enablement session (2028+).
 *
 * Patent priority anchor: F-AMBIENT-IOT-PER-SKU-001.
 * Scaffold session: IOT-Z20-AMBIENT-SCAFFOLD-1.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const ENOCEAN_CAPABILITIES = {
  configKeys: {},
  telemetryTypes: ['temperature_c', 'humidity_pct', 'light_lux'],
  alertingMode: 'cloud',
  otaSupported: false,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 0,
};

export class EnoceanAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'enocean', ENOCEAN_CAPABILITIES);
  }
}

export function createEnoceanAdapterFactory() {
  return (device) => new EnoceanAdapter(device);
}
